import React from 'react';
import { useParams } from 'react-router-dom';
import { ResponsiveLayout } from '@/components/ResponsiveLayout';
import { ChannelSettingsContent } from '@/components/ChannelSettingsContent';
import { MinimizedSidebar } from '@/components/MinimizedSidebar';

export default function ChannelSettingsPage() {
  const { ibId } = useParams();
  
  // Mock IB data - in real app this would come from API/context
  const ibData = {
    id: ibId,
    name: ibId === 'ib-fira-001' ? 'FIRA IND' : `IB ${ibId}`,
  };

  return (
    <ResponsiveLayout><div className="flex-1 min-h-screen bg-[#0A0A0B] text-[#F8F9FA]">
      <MinimizedSidebar />
      <main className="flex-1 overflow-hidden flex flex-col">
        <ChannelSettingsContent ib={ibData} />
      </main>
    </div>
    </ResponsiveLayout>
  );
}
